import { render, staticRenderFns } from "./serviceItems.vue?vue&type=template&id=2580dc5c&scoped=true"
import script from "./serviceItems.vue?vue&type=script&lang=js"
export * from "./serviceItems.vue?vue&type=script&lang=js"
import style0 from "./serviceItems.vue?vue&type=style&index=0&id=2580dc5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2580dc5c",
  null
  
)

export default component.exports